import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { FC, useEffect, useMemo, useState } from 'react';

import { createColumnDependencies } from 'components/ModelList/columns';
import { useURLFilters } from 'hooks/useURLFilters';
import { useURLSearchParams } from 'hooks/useURLSearchParams';

import { workflowTypesOptions } from '../../../../../model/types';
import { useFilterExtras } from '../shared/FilterContext';

export const dependencies = createColumnDependencies((ids) => [
  ids.WORKFLOWS_TYPE,
]);

type InnerProps = { columnId: string };

const getOptionLabel = (id: string): string =>
  workflowTypesOptions.find((opt) => opt.id === id)?.name ?? id;

const Inner: FC<InnerProps> = () => {
  // undated - no arguments
  const { updateFilterModelItems } = useURLFilters();
  const [searchParams] = useURLSearchParams();
  const { typeOptions } = useFilterExtras();

  const urlTypes: string | null = searchParams.types ?? null;

  const current: string[] = useMemo(
    () =>
      urlTypes
        ?.split(',')
        .map((s) => s.trim())
        .filter(Boolean) ?? [],
    [urlTypes]
  );

  const [value, setValue] = useState<string[]>(current);

  useEffect(() => setValue(current), [current]);

  return (
    <Stack p={1}>
      <Autocomplete<string, true, false, false>
        multiple
        options={typeOptions ?? []}
        value={value}
        getOptionLabel={getOptionLabel}
        onChange={(_, values) => {
          setValue(values);
          const next = values.length ? values.join(',') : null;
          if (urlTypes === next) return; // guard
          updateFilterModelItems({ types: next } as any);
        }}
        renderInput={(params) => (
          <TextField {...params} label="Type" size="small" />
        )}
      />
    </Stack>
  );
};

const TypeMultiSelect: FC = () => {
  const [WORKFLOWS_TYPE] = dependencies;
  if (!WORKFLOWS_TYPE) return null;

  return <Inner columnId={WORKFLOWS_TYPE} />;
};

export default TypeMultiSelect;
